import { useSelector } from "react-redux";
import { ReduxStore } from "$redux/reducers";
import { IPaymentCreditCard } from "$redux/reducers/paymentReducers";

export const usePaymentSelectors = () => {
    const payment = useSelector<ReduxStore, IPaymentCreditCard>((store) => store.payment);
    return { payment };
};
